<template>
  <div>
    <section class="nothing" v-if="isFast">
      <span>
        <!-- <img src="../assets/imgs/no.jpg" alt /> -->
        <img src="../assets/imgs/noResult.png" alt />
        <p>{{ TLang('没有找到相关商品哦', 'quick') }}</p>
      </span>
    </section>

    <section class="nothing" v-else-if="['lxActivity', 'lxHotel', 'lxScenery'].includes(path) && (!locationInfo || !locationInfo.lng || !locationInfo.lat) && needLocation">
      <span>
        <!-- <img src="../assets/imgs/no.jpg" alt /> -->
        <img src="../assets/imgs/noLocation.png" alt />
        <p>{{ TLang('未授权定位信息，请先打开定位', 'quick') }}</p>
      </span>
    </section>

    <section class="tabNothing" v-else-if="tabs && tabs.length > 1">
      <CardChoose :isCardRights="isCardRights" @changeCardChoose="chooseCard" v-if="cardInfos.length > 0" />
      <div class="noResult">
        <!-- <img src="../assets/imgs/no.jpg" alt /> -->
        <img src="../assets/imgs/noResult.png" alt />
        <p>
          <!-- {{ TLang('暂无匹配商品，更换筛选项试试吧', 'result') }} -->
          {{ TLang('sorry1', 'result') }}
          <span class="tipsKey">{{ key }}</span>
          {{ TLang('sorry2', 'result') }}
          <br />
          {{ TLang('请修改条件重新查询', 'result') }}
        </p>
      </div>
    </section>

    <section class="recommend-list" v-else>
      <div class="noResult" v-if="!(recommendList && recommendList.length)">
        <img src="../assets/imgs/noResult.png" alt />
      </div>
      <section class="tips">
        <p>
          {{ TLang('sorry1', 'result') }}
          <span class="tipsKey">{{ key }}</span>
          {{ TLang('sorry2', 'result') }}
          <br />
          {{ TLang('请修改条件重新查询', 'result') }}
        </p>
      </section>

      <section class="list-wrap" v-if="recommendList && recommendList.length">
        <h3>{{ TLang('为你推荐', 'result') }}</h3>
        <ul class="list">
          <li @click="recommendClickHandle(goods)" v-for="goods in recommendList" :key="goods.id">
            <div class="lexiangItem" v-if="goods.productType === '亲子活动' || goods.productType === '亲子酒店' || goods.productType === '玩乐门票'">
              <a :href="goods.h5SkipUrl">
                <LexiangResult :item="goods" />
              </a>
            </div>
            <div class="item" v-else>
              <a class="item-wrap" :href="goods.h5SkipUrl || 'javascript:void(0)'">
                <div class="goods-img">
                  <img class="" :src="goods.imgUrl || 'https://image.dongfangfuli.com/2019/02/19/ce48ca85bb539aad6f0497386d42cd314ed7cb43a3eea73db963e20d8ae7996a.png'" alt="" />
                  <div v-show="goods.hasPromoSticker" v-for="(item, itemIndex) in goods.promoStickerInfo" :key="itemIndex">
                    <PromoSticker :src="item.mktIcon"></PromoSticker>
                  </div>
                  <NoDeliver v-if="goods.unDelivery && addressGray" />
                  <NoStock v-else-if="goods.tags && goods.tags.bizStock === 0" />
                  <ReStock v-else-if="(!goods.tags || goods.tags.bizStock === null) && goods.stockNum !== null && goods.stockNum <= 0" />
                </div>
                <p class="goods-name">
                  <FrontendTag :tags="getTitleTags(goods.promoTags)" :isOnlyLine="false" :isWrap="false" /><span>{{ goods.name }}</span>
                </p>

                <div class="goods-tags">
                  <GoodsLabel :data="goods.promoTags" v-if="goods.tags && goods.hasPromoTags"></GoodsLabel>
                </div>
                <div class="goods-bottom">
                  <div :class="{listCartLeft : !(goods.tags && goods.tags.groupItem === 'Y') && !(goods.unDelivery && addressGray)}">
                    <div v-if="goods.tags && goods.tags.groupItem === 'Y'" style="width: '100%'">
                      <div>
                        <BusinessCoupon :discountPrice="goods.discountPrice" :discount="goods.discount" :discountTagShow="goods.discountTagShow" :noText="true" showType="recommend"></BusinessCoupon>
                      </div>
                      <FppGoodsPrice
                        :price="goods.tags.groupItemPrice"
                        :unionIcon="union_icon || require('../assets/imgs/fudou.png')"
                        :type="goods.tags.groupItemClassStyle"
                        :limitPrice="goods.tags.groupItemPriceLimit"
                        :showSymbolIcon="goods.tags.groupItemShowRmbSymbol"
                      />
                    </div>
                    <GoodsPrice
                      v-else-if="goods.dfPriceVo && (goods.dfPriceVo.purplePrice || goods.dfPriceVo.redPrice)"
                      :info="goods"
                      :price="goods.tags && goods.tags.promPrice ? goods.tags.promPrice : goods.sellingPrice"
                      :unionIcon="union_icon || require('../assets/imgs/fudou.png')"
                      :crossedPrice="
                        goods.tags && goods.tags.promPrice ?
                        goods.tags.salePrice || goods.sellingPrice : ''
                      "
                      :isShowIcon="true"
                      showType="recommend"
                    ></GoodsPrice>
                    <div v-else>
                      <div>
                        <BusinessCoupon :discountPrice="goods.discountPrice" :discount="goods.discount" :discountTagShow="goods.discountTagShow" :noText="true" showType="recommend"></BusinessCoupon>
                      </div>
                      <div class="price">
                        <img :src="union_icon || require('../assets/imgs/fudou.png')" alt="" />
                        <span :class="['big-price', getFontSize(parseFloat(((goods.sellingPrice || 0) * unionScale).toFixed(2) || 0))] == 2 ? 'smallFont' : 'bigFont'">{{
                          parseFloat(((goods.sellingPrice || 0) * unionScale).toFixed(2) || 0)
                        }}</span>
                      </div>
                    </div>
                  </div>

                  <div v-if="!(goods.tags && goods.tags.groupItem === 'Y') && !(goods.unDelivery && addressGray)" class="add-cart-btn">
                    <img v-if="goods.purchaseType === 1 && goods.type != 1" src="../assets/imgs/add_to_cart.png" @click.prevent="getGoodsInfo(goods)" alt="" />
                  </div>
                </div>
                <div class="preTag" :class="{ isBilingual: union_isBilingual }" v-if="goods.advanceSale">
                  <span>
                    {{ dfLang == 'en' ? TLang('起发货', result) + ' ' + dateFormat(goods.sendGoodsTimeStart) : dateFormat(goods.sendGoodsTimeStart) + ' ' + TLang('起发货', result) }}
                  </span>
                </div>
              </a>
            </div>
          </li>
        </ul>
      </section>
    </section>

    <div class="shop-cart" @click="toShopCart">
      <img class="shop-cart-icon" src="../assets/imgs/shop_cart_icon.png" alt="" />
      <span class="shop-cart-num" v-if="cartCount > -1">{{ cartCount }}</span>
    </div>

    <add-cart :isShow="isShow" :goods="activeGoods" @addCart="addToCart" @onClose="isShow = false" />
  </div>
</template>

<script>
import { mapState } from 'vuex';
import { checkUnifyShop, getQueryString, gioClickHandle, unionFlag, getCookieAddressInfo, getCookie } from '../utils';
import { checkXcx } from '../utils/checkXcx';
import { formatter } from '../utils/raf';
import { publicFunc } from '../utils/func';
import AddCart from './AddCart';
import PromoSticker from './PromoSticker';
import NoStock from './NoStock';
import ReStock from './ReStock';
import SingleTag from './SingleTag';
import NoDeliver from './NoDeliver';
import FrontendTag from './FrontTag.vue';
import { getGoodsInfo, addToCart, getTags } from '../assets/js/api';
import { fetchTagsList, dealTagsList } from "../tags";
import GoodsLabel from './GoodsLabel';
import BusinessCoupon from './BusinessCoupon';
import CardChoose from './CardChoose';
import LexiangResult from './LexiangResult';
import FppGoodsPrice from './FppGoodsPrice';
import GoodsPrice from "./GoodsPrice";
import { Toast } from 'vant';
export default {
  name: 'nothing',

  components: {
    AddCart,
    PromoSticker,
    GoodsLabel,
    NoStock,
    BusinessCoupon,
    CardChoose,
    LexiangResult,
    SingleTag,
    NoDeliver,
    FrontendTag,
    ReStock,
    FppGoodsPrice,
    GoodsPrice,
  },

  props: {
    needLocation: {
      type: Boolean,
      default: false,
    },
    path: {
      type: String,
      default: '',
    },
    isFast: {
      type: Boolean,
      default: false,
    },
    tabs: {
      type: Array,
      default: () => [],
    },
    locationInfo: {
      type: Object,
      default: () => {},
    },
    addressGray: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      isCardRights: getQueryString('cardChoose') ? Number(getQueryString('cardChoose')) : 0,
      union_icon: window.union_icon,
      unionScale: window.union_scale || 1,
      union_isBilingual: window.union_isBilingual,
      key: getQueryString('key'),
      isShow: false,
      activeGoods: {},
      isAddBuyClick: false,
      productTypes: getQueryString('productTypes'),
      // locationInfo: JSON.parse(localStorage.getItem("systemLoaction")) || JSON.parse(sessionStorage.getItem("systemLoaction")),
      // longitude: this.locationInfo && this.locationInfo.location.lng || publicFunc.getCookie("user_location_longitude") || sessionStorage.getItem('longitude'),
      // latitude: this.locationInfo && this.locationInfo.location.lat || publicFunc.getCookie("user_location_latitude") || sessionStorage.getItem('latitude'),
      addressInfo: getCookieAddressInfo() || JSON.parse(getCookie('address')) || {}, // 缓存地址信息
    };
  },
  mounted() {
    if (!this.isFast && this.recommendList && this.recommendList.length) {
      const gioParams = {
        df_searchKeyword: this.key,
      };
      // 有推荐商品时触发
      gioClickHandle('DF_exposureEvent', gioParams);
    }
  },
  computed: {
    ...mapState({
      recommendList: (state) => state.recommendList,
      cartCount: (state) => state.cartCount,
      loginInfo: (state) => state.loginInfo,
      // addressInfo: (state) => state.addressInfo,
      cardInfos: (state) => state.quick.cardInfos,
    }),
  },

  watch: {},

  created() {
    // console.log(this.recommendList)
    this.$store.dispatch('getAddressInfo');
    this.$store.dispatch('checkLogin');
  },

  methods: {
    getTitleTags(promoTags) {
      let arr = [];
      if (promoTags && promoTags.length > 0) {
        arr = promoTags.filter((item) => this.constant.titleTags.includes(item.mktFrontType));
      }
      return arr;
    },
    // 转换时间格式
    dateFormat(time) {
      time = formatter(new Date(time), 'YYYY-MM-DD');
      return time;
    },
    getSmallPrice(sellingPrice) {
      const total = ((sellingPrice || 0) * this.unionScale).toFixed(2).toString();
      return total.split('.')[1];
    },
    // 获取金额字体大小（超过一行，字号减小到14px）
    getFontSize(price) {
      let fontLength = String(parseFloat(price)).length;
      if (fontLength >= 10) {
        return 2;
      } else {
        return 1;
      }
    },
    /**
     * 获取加购商品信息
     * @param { Object } goods 商品信息
     */
    async getGoodsInfo(goods) {
      this.isAddBuyClick = true;
      const params = {
        categoryId: goods.categoryId,
        spuId: goods.mallSpuId,
      };
      const res = await getGoodsInfo(params);
      const { body, code, msg } = res.data;
      if (code !== 0) {
        Toast.fail(msg);
        return;
      }
      // 单规格
      if (body.length === 1) {
        const myChoose = {
          categoryId: goods.categoryId,
          goodsId: goods.id,
          goodsNum: body[0].buyMin || 1,
        };
        this.addToCart(myChoose);
        return;
      }
      let ids = [];
      body &&
        body.map((item) => {
          if (item.categoryId && item.goodsId) {
            ids.push({ goodsId: item.goodsId, categoryId: item.categoryId });
          }
        });
      getTags(ids).then((res) => {
        if (res && res.data && res.data.body) {
          res.data.body.map((item) => {
            const index = body.findIndex(
              (t) =>
                t.goodsId === item.goodsId && t.categoryId === item.categoryId
            );
            let good = {
              goodsId: item.goodsId,
              categoryId: item.categoryId,
            };
            good = dealTagsList(res.data.body, good, null, true, true, false);
            if (index > -1) {
              body[index].tags = item && item;
              body[index].promoStickerInfo = good.promoStickerInfo || [];
              body[index].hasPromoSticker = good.hasPromoSticker;
              body[index].hasPromoTags = good.hasPromoTags;
              body[index].promoTags = good.promoTags || [];

              body[index].bizStock = item.bizStock;
              // 折上折
              body[index].mktTagShow = good.mktTagShow;
              body[index].discountTagShow = good.discountTagShow;
              body[index].discountPrice = good.discountPrice;
              body[index].discount = good.discountEnText;
              // body[index].discountEnText = good.discountEnText;

              body[index].totalLimit = good.totalLimit;
              body[index].saleNum = good.saleNum || 0;
              body[index].dfPriceVo = good.dfPriceVo || null;
            }
          });
        }
        this.activeGoods = JSON.parse(JSON.stringify(goods));
        this.activeGoods.goodsSpecList = JSON.parse(JSON.stringify(body));
        // console.log(this.activeGoods);
        this.isShow = true;
      });
      // this.activeGoods = goods;
      // this.activeGoods.goodsSpecList = body;
      // this.isShow = true;
    },

    /**
     * 加入购物车
     * @param { Object }   myChoose 商品信息
     */
    async addToCart(myChoose) {
      if (this.loginInfo.loginFlag === 0) {
        const _window = window;
        if (_window && _window.__wxjs_environment === 'miniprogram') {
          // 跳转小程序
          return _window.wx.miniProgram.redirectTo({ url: '/pages/login/login' });
        }
        let curUrl = window.location.href;
        window.df_sdk_common.location.href = this.loginInfo.loginUrl + '&returnUrl=' + encodeURIComponent(curUrl);
        return;
      }
      // this.chooseOfAdd = myChoose;
      const cartAddress = {
        cityId: this.addressInfo.cityId,
        cityName: this.addressInfo.cityName,
        provinceId: this.addressInfo.provinceId,
        provinceName: this.addressInfo.provinceName,
        regionId: this.addressInfo.districtId,
        regionName: this.addressInfo.districtName,
        streetId: this.addressInfo.streetId,
        streetName: this.addressInfo.streetName,
      };
      const params = {
        ...myChoose,
        // ...this.addressInfo,
        ...cartAddress,
      };
      const res = await addToCart(params);
      const { code, msg } = res.data;
      if (code !== 0) {
        if (code === 101002) {
          const _window = window;
          if (_window && _window.__wxjs_environment === 'miniprogram') {
          // 跳转小程序
          return _window.wx.miniProgram.redirectTo({ url: '/pages/login/login' });
        }
          let curUrl = window.location.href;
          window.df_sdk_common.location.href = this.loginInfo.loginUrl + '&returnUrl=' + encodeURIComponent(curUrl);
        }
        Toast.fail(msg);
        return;
      }

      this.$store.dispatch('getCartCount');
      if (code === 0 && msg) {
        Toast.success(msg);
      } else {
        Toast.success(`${TLang('加入购物车成功', 'cart')}`);
      }
    },

    /**
     * 去购物车页面
     */
    toShopCart() {
      // 增加百福德兼容
      const union = unionFlag();
      if (checkXcx() && !union && !checkUnifyShop()) {
        const _window = window;
        _window.wx.miniProgram.redirectTo({ url: '/pages/shopingCar/shopingCar' });
      } else {
        // 增加百福德兼容
        const union = unionFlag();
        const urlParams = union ? `union=${union}&isHideTab=true&` : '';
        const curUrl = window.location.href;
        window.df_sdk_common.location.href = `/tmall/shopping/cart?${urlParams}return_url=${encodeURIComponent(curUrl)}`;
      }
    },

    recommendClickHandle(goods = {}) {
      const gioParams = {
        df_resultPage: '1',
        df_modulename: '为你推荐',
        df_elementname: this.isAddBuyClick ? '加购' : '商品详情',
        df_searchKeyword: this.key,
        df_goodsname: goods.name || '',
        df_spu_code: goods.mallSpuId || '',
      };
      // 点击推荐商品/加购推荐商品触发
      gioClickHandle('DF_elementClick', gioParams);
      this.isAddBuyClick = false;
    },

    // 切换卡选择
    chooseCard(data) {
      this.isCardRights = data;

      const { query } = this.$route;
      const path = window.location.pathname.replace('/ms/', '');
      this.$router
        .replace({
          name: path,
          query: { ...query, cardChoose: data },
        })
        .catch(() => {});
      this.$emit('handlerUpdata', { isCardRights: data }, 1);
    },
  },
};
</script>

<style lang="less" scoped>
@375: 320/375;
.nothing {
  display: table;
  width: 100%;
  height: 50%;
  text-align: center;
  font-size: 12.8px;
  color: #999;
  padding-top: 132px;
  > span {
    display: table-cell;
    vertical-align: middle;
    > img {
      width: 222px;
      vertical-align: top;
      margin-bottom: 10px;
    }
  }
}
.noResult {
    margin-top: 30px;
    width: 100%;
    > img {
      display: block;
      width: 222px;
      margin: 10px auto;
    }
  }
.tabNothing {
  width: 100%;
  text-align: center;
  padding: 0 15px * @375;
  box-sizing: border-box;
  font-size: 12.8px;
  color: #999;

  // > span {
  //   display: table-cell;
  //   vertical-align: middle;
  //   > img {
  //     width: 222px;
  //     vertical-align: top;
  //     margin-bottom: 10px;
  //   }
  // }
}
.tipsKey {
  color: #3FA6FF;
}
.recommend-list {
  padding: 0 10px * @375 32px * @375;
  .tips {
    margin-bottom: 20px * @375;
    font-size: 14px * @375;
    color: #666;
    text-align: center;
    line-height: 18px * @375;
    width: 100%;
    box-sizing: border-box;
    padding: 0 30px * @375;

    .noLxTip {
      font-size: 14px * @375;

      font-weight: 400;
      color: #333333;
      line-height: 20px * @375;
      margin: 0;
      padding: 0;
    }
  }
  .list-wrap {
    h3 {
      font-size: 14px;
      color: #333;
      font-weight: bold;
      line-height: 20px;
    }
    .list {
      display: flex;
      justify-content: space-between;
      flex-wrap: wrap;
      li {
        // width: 100%;
      }
    }
    .lexiangItem {
      padding: 15px * @375 5px * @375 0;
      width: 100%;
      box-sizing: border-box;
    }
    .item {
      margin-top: 10px;
      width: 146px;
      box-shadow: 0px 2px 9px 0px rgba(0, 0, 0, 0.05);
      border-radius: 3px;
      padding: 14px 0 3px;
    }
    .item-wrap {
      display: block;
      text-align: center;
      padding: 0 6px;
      position: relative;
      box-sizing: border-box;
      width: 100%;
    }
    .goods-img {
      width: 134px;
      height: 134px;
      margin-bottom: 18px;
      position: relative;
      img {
        width: 134px;
        height: 134px;
      }
    }
    .goods-name {
      font-size: 12px * @375;
      color: #333;
      line-height: 16px * @375;
      height: 32px * @375;
      margin-bottom: 2px * @375;
      text-align: left;
      white-space: normal;
      display: -webkit-box;
      -webkit-box-orient: vertical;
      -webkit-line-clamp: 2;
      overflow: hidden;
      text-overflow: ellipsis;
      .df-frontend-tag {
        vertical-align: text-top;
        top: 0;
      }
    }
    .goods-tags {
      display: flex;
      height: 20px * @375;
      margin-bottom: 10px * @375;
    }
    .goods-bottom {
      display: flex;
      align-items: flex-end;
      justify-content: space-between;
      padding-bottom: 5px * @375;
      width: 100%;
      & > .listCartLeft {
        width: calc(100% - 28px * @375);
      }
    }
    .price {
      display: flex;
      align-items: baseline;
      line-height: 1;
      color: #ff5757;
      font-weight: 600;
      img {
        width: 12px * @375;
        height: 12px * @375;
      }
    }
    .big-price {
      font-size: 18px * @375;
    }
    .bigFont {
      font-size: 18px * @375;
      line-height: 18px * @375;
    }
    .smallFont {
      font-size: 14px * @375;
    }
    .small-price {
      font-size: 10px * @375;
    }
    .add-cart-btn {
      width: 24px * @375;
      height: 24px * @375;
      font-size: 0;
      line-height: 0;
      flex-shrink: 0;
      img {
        display: block;
        width: 24px * @375;
        height: 24px * @375;
      }
    }
  }
}

.shop-cart {
  width: 42px;
  height: 42px;
  position: fixed;
  bottom: 100px;
  right: 12px;
  z-index: 999;
  .shop-cart-icon {
    width: 42px;
    height: 42px;
  }
  .shop-cart-num {
    position: absolute;
    right: -2px;
    top: 0;
    background: #f44545;
    color: #fff;
    padding: 3px 6px;
    font-size: 12px;
    line-height: 1;
    border-radius: 10px;
  }
}
.preTag {
  width: 134px;
  background: url('../assets/imgs/pre-sale.png');
  line-height: 24px;
  height: 24px;
  color: #fff;
  font-size: 11px;
  background-size: 153px 24px;
  background-repeat: no-repeat;
  position: absolute;
  top: 110px;
  left: 6px;
  span {
    margin-left: 35px;
    line-height: 24px;
    height: 100%;
    font-size: 8px;
    display: inline-block;
  }
}
.isBilingual {
  background-image: url('../assets/imgs/pre-sale-en.png');
}
</style>
